export function initChunkErrorReloadGuard() {
    const RELOAD_KEY = 'chunk_error_reload_ts';
    const RELOAD_COUNT_KEY = 'chunk_error_reload_count';

    const ONE_HOUR = 60 * 60 * 1000;

    function canReload(): boolean {
        sessionStorage.setItem('canReload', String(Date.now()));
        const last = sessionStorage.getItem(RELOAD_KEY);
        if (!last) return true;

        return Date.now() - Number(last) > ONE_HOUR;
    }

    function markReload() {
        sessionStorage.setItem(RELOAD_KEY, String(Date.now()));

        const currentCount = Number(localStorage.getItem(RELOAD_COUNT_KEY) ?? '0');

        localStorage.setItem(
            RELOAD_COUNT_KEY,
            String(currentCount + 1)
        );
    }

    function getErrorText(error: unknown): string {
        if (error instanceof Error) {
            return `${error.name}: ${error.message}`;
        }

        if (typeof error === 'string') {
            return error;
        }

        try {
            return JSON.stringify(error);
        } catch {
            return String(error);
        }
    }

    function reloadOnChunkError(text: string) {
        sessionStorage.setItem('reloadOnChunkError', String(Date.now()));

        const isChunkError =
            text.includes('Failed to fetch dynamically imported module') ||
            text.includes('Importing a module script failed') ||
            text.includes('Loading chunk') ||
            text.includes('ChunkLoadError');

        if (!isChunkError) return;

        if (canReload()) {
            markReload();
            window.location.reload();
        }
    }

    window.addEventListener('error', (event) => {
        reloadOnChunkError(event.message || getErrorText(event.error));
    });

    window.addEventListener('unhandledrejection', (event) => {
        reloadOnChunkError(getErrorText(event.reason));
    });
}
